import gql from 'graphql-tag';

export default gql`
  mutation deleteReports($termMonthIds: [ID!]!) {
    deleteReports(termMonthIds: $termMonthIds)
  }
`;
